<div class="container-fluid">
    <div class="row">
        <div *ngIf="showHeading" class="col-12">
            <h1 *ngIf="!dashboardView" class="mb-4">Create a Portfolio</h1>
            <h2 *ngIf="dashboardView" class="mb-4">Merchant Details</h2>
        </div>
        <div class="col-12">
            <form (ngSubmit)="save()" [formGroup]="formGroup" class="needs-validation" novalidate>
                <div class="form-group mb-4">
                    <label>Who's listing?</label>
                    <input
                        class="form-control"
                        [class.is-invalid]="formGroup.get('companyName')?.invalid && formGroup.get('companyName')?.touched"
                        formControlName="companyName"
                        id="companyName"
                        name="companyName"
                        placeholder="Company / Owner Name"
                        required
                        type="text"
                    />
                    <div class="invalid-feedback" invalidMessage="companyName">{{ formGroup.get('companyName') | validationErrors }}</div>
                </div>
                <div class="form-group mb-4">
                    <label>Company Registration <small>(Optional)</small></label>
                    <input class="form-control" formControlName="companyRegistration" id="companyRegistration" name="companyRegistration" placeholder="Company Registration" type="text" />
                </div>
                <div class="form-group mb-4">
                    <label>Vat Number <small>(Optional)</small></label>
                    <input class="form-control" formControlName="vatNumber" id="vatNumber" name="vatNumber" placeholder="Vat Number" type="text" />
                </div>
                <div *ngIf="dashboardView" class="form-group mb-4">
                    <label>Invoice Details <small>(Optional)</small></label>
                    <textarea class="form-control" formControlName="invoiceDetails" id="invoiceDetails" name="invoiceDetails" placeholder="Additional details to appear on invoices (e.g. address)" rows="3"></textarea>
                    <div class="form-text">These details will appear on your payout notices and proforma invoices</div>
                </div>
                <div *ngIf="!dashboardView && !merchantKey && isAdminCreateMerchant" class="form-group mb-4">
                    <label>Portfolio Owner Email</label>
                    <input
                        class="form-control"
                        [class.is-invalid]="formGroup.get('email')?.invalid && formGroup.get('email')?.touched"
                        formControlName="email"
                        id="email"
                        name="email"
                        placeholder="Email"
                        required
                        type="email"
                    />
                    <div class="invalid-feedback" invalidMessage="email">{{ formGroup.get('email') | validationErrors }}</div>
                </div>
                <div *ngIf="!dashboardView" class="form-group mb-4">
                    <label class="form-label mb-3">Choose Your Platform</label>

                    <div class="form-check mb-3">
                        <input class="form-check-input" formControlName="bookuppEnabled" id="parkupp" name="bookuppEnabled" type="radio" [value]="false" />
                        <label class="form-check-label" for="parkupp"> <strong>Monthly Parking</strong> <span class="badge bg-primary ms-2">Default</span> </label>
                        <div class="form-text">
                            A digital first mobile and web-based parking marketplace that connects drivers with vacant parking bays—monthly or once-off—across South Africa's city centers.
                        </div>
                    </div>

                    <div class="form-check mb-3">
                        <input class="form-check-input" formControlName="bookuppEnabled" id="allocate" name="bookuppEnabled" type="radio" [value]="true" />
                        <label class="form-check-label" for="allocate">
                            <strong>Allocate</strong>
                        </label>
                        <div class="form-text">
                            Allocate is a real-time, visual platform for corporate clients to allocate internal office parking fairly and efficiently, especially in hybrid or hot-desking environments.
                        </div>
                    </div>
                </div>

                <div *ngIf="authenticationService.isAdmin && dashboardView" class="form-group mb-4 admin-only">
                    <label>ParkUpp Fee Exception</label>
                    <input class="form-control" formControlName="commissionPercentage" id="commissionPercentage" name="commissionPercentage" type="number" />
                </div>

                <div *ngIf="dashboardView" class="form-group mb-4">
                    <label>Parking Contact Number <small>(Optional)</small></label>
                    <div class="input-group">
                        <ngx-intl-tel-input
                            [cssClass]="'form-control'"
                            [enableAutoCountrySelect]="true"
                            [enablePlaceholder]="true"
                            [numberFormat]="PhoneNumberFormat.National"
                            [phoneValidation]="false"
                            [preferredCountries]="preferredCountries"
                            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                            [searchCountryFlag]="true"
                            [selectFirstCountry]="false"
                            [selectedCountryISO]="CountryISO.SouthAfrica"
                            [separateDialCode]="separateDialCode"
                            formControlName="phone"
                        >
                        </ngx-intl-tel-input>
                    </div>
                    <div class="form-text">This number will be used for parking-related inquiries</div>
                </div>
                <div *ngIf="!valid && formGroup.invalid" class="alert alert-danger">
                    <strong>Please complete the following required fields:</strong>
                    <ul class="mb-0 mt-2">
                        <li *ngIf="formGroup.get('companyName')?.invalid && formGroup.get('companyName')?.touched">Company / Owner Name</li>
                        <li *ngIf="formGroup.get('email')?.invalid && formGroup.get('email')?.touched && !merchantKey && isAdminCreateMerchant">Portfolio Owner Email</li>
                        <li *ngIf="formGroup.get('bookuppEnabled')?.invalid && formGroup.get('bookuppEnabled')?.touched">Platform Selection</li>
                    </ul>
                </div>
                <button [disabled]="loading" class="btn btn-enterprise-secondary mb-3" type="submit"><i *ngIf="loading" class="fa fa-circle-notch fa-spin"></i><span *ngIf="!loading">Save</span></button>
                <div *ngIf="error" class="alert alert-warning">
                    {{ error }}
                </div>
            </form>
        </div>
    </div>
</div>
